(function () {
  'use strict';

  angular.module('pages.recoverPassword', [
    'pages.recoverPassword.emailInput',
    'pages.recoverPassword.newPassword',
  ]);
})();
